<template>
  <div class="app-content">
    <el-container v-loading="loading">
      <side-menu
        :menu-list="filteredMenu"
        @setMenuPined="menuPined = $event"
        :currentCompany="currentCompany"
        class="side-menu"
      ></side-menu>
      <el-main :class="{ 'not-pined': !menuPined }">
        <router-view ref="child" @changeCompany="companyChanged"></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import SideMenu from "./SideMenu"
import { menuList } from "./static"
import { checkCompanyPermission, canManageCompany } from "@/utils/checkPermission"
import { getCurCompany } from "@/api/userCenter/company"

export default {
  name: "CompanyLayout",
  components: {
    SideMenu
  },
  data() {
    return {
      loading: false,
      menuPined: true,
      currentCompany: {}
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo || {}
    },
    filteredMenu() {
      return menuList
        .map(menu =>
          Object.assign({}, menu, {
            children: menu.children?.filter(submenu => {
              switch (submenu.label) {
                case "企业操作":
                  return this.currentCompany.ownerId === this.curUser.userId
                case "邀请审核":
                  return (
                    !this.currentCompany.syncDing &&
                    checkCompanyPermission({ companyId: this.curUser.companyId, pri: "邀请审核" })
                  )
                case "应用列表":
                case "项目列表": {
                  let pri = submenu.label
                  return (
                    checkCompanyPermission({
                      companyId: this.curUser.companyId,
                      pri
                    }) ||
                    checkCompanyPermission({
                      companyId: this.curUser.companyId,
                      pri: pri + "(我管理的)"
                    })
                  )
                }
                case "应用模板":
                case "项目模板": {
                  let pri = submenu.label
                  return (
                    checkCompanyPermission({
                      companyId: this.curUser.companyId,
                      pri
                    }) ||
                    checkCompanyPermission({
                      companyId: this.curUser.companyId,
                      pri: pri + "(我创建的)"
                    })
                  )
                }
                default: {
                  return checkCompanyPermission({
                    companyId: this.curUser.companyId,
                    pri: submenu.label
                  })
                }
              }
            })
          })
        )
        .filter(menu => menu.public || !this._.isEmpty(menu.children))
    }
  },
  watch: {
    $route: function() {
      this.checkPri()
    }
  },
  mounted() {
    this.loading = true
    getCurCompany().then(currentCompany => {
      this.loading = false
      this.currentCompany = currentCompany
      this.checkPri()
    })
  },
  methods: {
    checkPri() {
      if (!canManageCompany(this.curUser.companyId)) {
        this.$message.error("权限不足")
        this.$router.push({ name: "home" })
        return
      }
      // 如果没有当前路由的权限,则默认打开第一个可见菜单
      let subMenus = this.filteredMenu.flatMap(group => (group.children ? group.children : group))
      for (let subMenu of subMenus) {
        if (subMenu.value === this.$router.currentRoute.name) return
      }
      if (subMenus[0]?.value) {
        if (
          !["company-invite-setting", "company-joint-setting"].includes(
            this.$router.currentRoute.name
          )
        ) {
          this.$message.error("权限不足")
          this.menuSelect(subMenus[0].value)
        }
      } else {
        this.$message.error("权限不足")
        this.$router.push({ name: "home" })
      }
    },
    menuSelect(routeName) {
      if (this.$router.currentRoute.name === routeName) return
      this.$router.push({ name: routeName })
    },
    companyChanged() {
      getCurCompany().then(currentCompany => (this.currentCompany = currentCompany))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-content {
  width: 100%;
  height: 100%;
  z-index: 10;
  .el-container {
    height: 100%;
    .side-menu {
      position: absolute;
      left: 0;
      top: 0;
      width: 240px;
      height: 100%;
      z-index: 2;
      background-color: #fff;
      box-shadow: 0 2px 4px rgba(33, 43, 54, 0.1);
      color: #2a304d;
    }
    .el-main {
      background: #ffffff;
      position: relative;
      height: 100%;
      margin-left: 240px;
      padding: 15px 0;
      overflow: auto;
      z-index: 1;
      &.not-pined {
        margin-left: 52px;
      }
    }
  }
}
</style>
